/**
 * Ce qu'un effacement de compte va emporter.
 *
 * CE FICHIER A ETE REDUIT A CETTE SEULE FONCTION, le 18 septembre 2026.
 *
 * Il portait onze autres exports — getStats, getAllPeople, getPeopleByUuid,
 * createPeople, updatePeople, deletePeople et leurs alias « Person ». Aucun
 * n'etait atteint : les composants les importent depuis `apiService.js`, qui
 * les reexporte de `@cabaza/shared`. C'etaient deux implementations
 * concurrentes du meme nom, et c'est la copie oubliee qui finit par diverger.
 *
 * Une seule ligne de tout le projet importe ce fichier — apiService.js:31,
 * pour la fonction ci-dessous.
 *
 * ELLE NE FONCTIONNAIT PAS. `enTetesAuth` etait appelee sans etre importee :
 * chaque appel levait un ReferenceError, que le catch transformait en `{}`.
 * L'ecran de suppression de compte affichait donc TOUJOURS un apercu vide —
 * « aucun abonnement, aucune facture, aucun fichier » — a des gens qui
 * allaient effacer definitivement leur compte. Une panne muette, sur le geste
 * le plus irreversible de l'application.
 */

import { enTetesAuth } from './enTetesAuth';

const API_BASE_URL = 'https://apicabaza.creago.be/rest/cabaza/peoples';

export async function previsualiserEffacement(uuid) {
    try {
        const response = await fetch(`${API_BASE_URL}/${uuid}/previsualiser-effacement`, {
            method: 'GET',
            headers: enTetesAuth()
        });

        if (!response.ok) return {};

        const data = await response.json();
        const brut = data?.data ?? data?.DATA ?? {};

        // Les cles arrivent en minuscules depuis ColdFusion.
        return {
            aUnAbonnement: brut.aUnAbonnement ?? brut.aunabonnement ?? false,
            aDesFactures: brut.aDesFactures ?? brut.adesfactures ?? false,
            nbFichiers: brut.nbFichiers ?? brut.nbfichiers ?? 0
        };
    } catch (error) {
        console.warn(`Previsualisation indisponible pour ${uuid}:`, error);
        return {};
    }
}